import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FeatureListLinearComponent } from './AppBaseComponents/FeaturesList/feature-list-linear/feature-list-linear.component';
import { FeatureListMainComponent } from './AppBaseComponents/FeaturesList/feature-list-main/feature-list-main.component';
import { AppRoutingModule } from './app-routing.module';
import { MatRadioModule } from '@angular/material/radio';
import { AppComponent } from './app.component';
import { LoginViewComponent } from './Views/login-view/login-view.component';
import { LibraryViewComponent } from './Views/library-view/library-view.component';
import { StudioViewComponent } from './Views/studio-view/studio-view.component';
import { ReportViewComponent } from './Views/report-view/report-view.component';
import { PageNotFoundViewComponent } from './Views/page-not-found-view/page-not-found-view.component';
import { PagePreviewComponentComponent } from './AppBaseComponents/page-preview-component/page-preview-component.component';
import { TopNavComponentComponent } from './AppBaseComponents/top-nav-component/top-nav-component.component';
import { SafePipePipe } from './Pipes/safe-pipe.pipe';
import { PaletteComponentComponent } from './AppBaseComponents/Palette/palette-component/palette-component.component';
import { PaletteListComponentComponent } from './AppBaseComponents/Palette/palette-list-component/palette-list-component.component';
import { FeatureComponent } from './AppBaseComponents/feature/feature.component';
import { ScenarioListComponent } from './AppBaseComponents/scenario-list/scenario-list.component';
import { ScenarioComponent } from './AppBaseComponents/scenario/scenario.component';
import { StepListComponent } from './AppBaseComponents/step-list/step-list.component';
import { StepComponent } from './AppBaseComponents/step/step.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextFilterPipe } from './Pipes/text-filter.pipe';
import { SidebarMainComponent } from './AppBaseComponents/Sidebar/sidebar-main/sidebar-main.component';
import { SidebarListComponent } from './AppBaseComponents/Sidebar/sidebar-list/sidebar-list.component';
import { StepViewComponent } from './Views/step-view/step-view.component';
import { ObjectListMainComponent } from './AppBaseComponents/ObjectsList/object-list-main/object-list-main.component';
import { ObjectListLinearComponent } from './AppBaseComponents/ObjectsList/object-list-linear/object-list-linear.component';
import { Canvas2Component } from './AppBaseComponents/canvas2/canvas2.component';
import { VideoComponent } from './AppBaseComponents/reportings/video/video.component';
import { LogsComponent } from './AppBaseComponents/reportings/logs/logs.component';
import { HtmlComponent } from './AppBaseComponents/reportings/html/html.component';
import { DoughnutComponent } from './AppBaseComponents/charts/doughnut/doughnut.component';
import { SafePipe } from './safe.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule, MatTabGroup, MatTooltip, MatTooltipModule, MAT_FORM_FIELD_DEFAULT_OPTIONS, MatInputModule, MatFormFieldModule, MatButtonModule, MatAutocompleteModule, MatProgressSpinnerModule, MatGridListModule, MatTreeModule, MatTableModule, MatSlideToggleModule, MatChipsModule } from '@angular/material';
import { CanvasComponent2Component } from './AppBaseComponents/canvas-component2/canvas-component2.component';
import { DragD1Component } from './demoComponent/drag-d1/drag-d1.component';
import { DragD2Component } from './demoComponent/drag-d2/drag-d2.component';
import { DragParentComponent } from './demoComponent/drag-parent/drag-parent.component';
import { DragD3Component } from './demoComponent/drag-d3/drag-d3.component';
import { DragD4Component } from './demoComponent/drag-d4/drag-d4.component';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { SharedService } from './Services/shared.service';
import { AddPageComponent } from './AppBaseComponents/add-page/add-page.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { AddWebObjectComponent } from './AppBaseComponents/add-web-object/add-web-object.component';
import { ReportStatsComponent } from './AppBaseComponents/report-stats/report-stats.component';
import { ExecutionContainerComponent } from './AppBaseComponents/execution-container/execution-container.component';
import { TestDataDialogComponent } from './AppBaseComponents/test-data-dialog/test-data-dialog.component';
import { FileUploadDnDComponent } from './AppBaseComponents/file-upload-dn-d/file-upload-dn-d.component';
import { NgxFileDropModule } from 'ngx-file-drop';
import { ReportSummaryComponent } from './AppBaseComponents/report-summary/report-summary.component';
import { ReportDetailsComponent } from './AppBaseComponents/report-details/report-details.component';
import { RestService } from './Services/rest.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DialogComponent } from './AppBaseComponents/dialog/dialog.component';
import { CsvWarningDialogComponent } from './AppBaseComponents/csv-warning-dialog/csv-warning-dialog.component';
import { HeadNavbarComponent } from './head-navbar/head-navbar.component';
import { StartupService } from './Services/startup.service';
import { ProjectResolver } from './Resovlers/project-resolver';
import { ProjectViewComponent } from './Views/project-view/project-view.component';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { AddElementComponent } from './AppBaseComponents/add-element/add-element.component';
import { ProgressSpinnerComponent } from './AppBaseComponents/progress-spinner/progress-spinner.component';
import { SearchPipe } from './Pipes/search.pipe';
import { RunideComponent } from './Views/runide/runide.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PaginationComponent } from './AppBaseComponents/pagination/pagination.component';
import { LoaderComponent } from './AppBaseComponents/reportings/loader/loader.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { StepwiseComponent } from './AppBaseComponents/reportings/stepwise/stepwise.component';
import { UpdatePasswordViewComponent } from './Views/update-password-view/update-password-view.component';
import { ForgotPasswordViewComponent } from './Views/forgot-password-view/forgot-password-view.component';
import { ResetPasswordViewComponent } from './Views/reset-password-view/reset-password-view.component';
import { TreeTableComponent } from './AppBaseComponents/tree-table/tree-table.component';
import { OrgStructureViewComponent } from './Views/org-structure-view/org-structure-view.component';
import { BaseOverlayFormComponent } from './AppBaseComponents/base-overlay-form/base-overlay-form.component';
import { WebsocketService } from './Services/websocket.service';
import { DurationPipe } from './Pipes/duration.pipe';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ShareTextModalComponent } from './AppBaseComponents/share-text-modal/share-text-modal.component';
import { VideoViewerViewComponent } from './Views/video-viewer-view/video-viewer-view.component';
import { LogViewComponent } from './Views/log-view/log-view.component';
import { ReportViewerViewComponent } from './Views/report-viewer-view/report-viewer-view.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CodeLinkageViewComponent } from './Views/code-linkage-view/code-linkage-view.component';
import { ProgressLoaderComponent } from './AppBaseComponents/progress-loader/progress-loader.component';
import { VisualComparisonComponent } from './AppBaseComponents/visual-comparison/visual-comparison.component';
import { CodeReviewViewComponent } from './Views/code-review/code-review-view/code-review-view.component';
import { CodeReviewCodeChangedComponent } from './AppBaseComponents/code-review-component/code-review-code-changed/code-review-code-changed.component';
import { CodeReviewReportComponent } from './AppBaseComponents/code-review-component/code-review-report/code-review-report.component';
import { CodeReviewConversationComponent } from './AppBaseComponents/code-review-component/code-review-conversation/code-review-conversation.component';
import { CodeReviewListViewComponent } from './Views/code-review/code-review-list-view/code-review-list-view.component';
import { AddCodeReviewComponent } from './AppBaseComponents/code-review-component/add-code-review/add-code-review.component';
import { TemplateComponent } from './Views/template/template.component';
import { GithubIntegrationViewComponent } from './Views/github-integration-view/github-integration-view.component';
import { CodeDiffViewerComponent } from './AppBaseComponents/code-diff-viewer/code-diff-viewer.component';
import { SafeHtmlPipe } from './Pipes/safe-html.pipe';
import { BAReviewComponent } from './Views/bareview/bareview.component';
import { BusniessReviewComponent } from './AppBaseComponents/busniess-review/busniess-review.component';
import { IntegrationViewComponent } from './Views/integration-view/integration-view.component';
import { MapProjectComponent } from './AppBaseComponents/map-project/map-project.component';
import { JiraIntegrationViewComponent } from './Views/jira-integration-view/jira-integration-view.component';
import { MappingArtifactComponent } from './AppBaseComponents/mapping-artifact/mapping-artifact.component';
import { AgileIntegrationViewComponent } from './Views/agile-integration-view/agile-integration-view.component';
import { AddApiObjectComponent } from './AppBaseComponents/add-api-object/add-api-object.component';
import { SelectObjectTypeComponent } from './AppBaseComponents/select-object-type/select-object-type.component';
import { ImportApiObjectsComponent } from './AppBaseComponents/import-api-objects/import-api-objects.component';
import { ApiResponseComponent } from './AppBaseComponents/api-response/api-response.component';
import { NotificationProfileViewComponent } from './Views/notification-profile-view/notification-profile-view.component';
import { SelectiveImportComponent } from './AppBaseComponents/selective-import/selective-import.component';
import { SlackIntegrationComponent } from './Views/slack-integration/slack-integration.component';
import { UserGuideComponent } from './user-guide/user-guide.component';
import { CiCdComponent } from './AppBaseComponents/ci-cd/ci-cd.component';
import { SuiteConfigSelectionDialogComponent } from './AppBaseComponents/suite-config-selection-dialog/suite-config-selection-dialog.component';
import { SuiteExecutionConfigDialogComponent } from './AppBaseComponents/suite-execution-config-dialog/suite-execution-config-dialog.component';
import { ReportdashboardComponent } from './Views/reportdashboard/reportdashboard.component';
import { TestCasesViewComponent } from './Views/test-cases-view/test-cases-view.component';
import { GenerateTestCaseComponent } from './AppBaseComponents/generate-test-case/generate-test-case.component';
import { AdminManagmentComponent } from './AppBaseComponents/admin-managment/admin-managment.component';
import { RaiseBugComponent } from './AppBaseComponents/raise-bug/raise-bug.component';
import { MobileStreamViewComponent } from './Views/mobile-stream-view/mobile-stream-view.component';
import { RecordedActionsComponent } from './Views/recorded-actions/recorded-actions.component';
import { ApkUploadComponent } from './Views/apk-upload/apk-upload.component';
import { GestureControlsComponent } from './Views/gesture-controls/gesture-controls.component';
import { DeviceScreenComponent } from './Views/device-screen/device-screen.component';
import { ApkUploadService } from './Services/apk-upload.service';
import { MobileSessionService } from './Services/mobile-session.service';
import { MobileLiveViewComponent } from './Views/mobile-live-view/mobile-live-view.component';
import { ImageSnippetDialogComponent } from './AppBaseComponents/image-snippet-dialog/image-snippet-dialog.component';
import { SuiteCanvasDialogComponent } from './AppBaseComponents/suite-canvas-component/suite-canvas-dialog.component';
import { TemplateConfigDialogComponent } from './AppBaseComponents/template-config-dialog/template-config-dialog.component';
import { TemplateResultDialogComponent } from './AppBaseComponents/template-result-dialog/template-result-dialog.component';
import { SchedulerComponent } from './Views/schedular/scheduler/scheduler.component';
import { CreateScheduleComponent } from './Views/schedular/create-schedule/create-schedule.component';
import { ScheduleListComponent } from './Views/schedular/schedule-list/schedule-list.component';
import { SchedulerExecutionHistoryComponent } from './Views/schedular/scheduler-execution-history/scheduler-execution-history.component';
import { WebRecorderSessionComponent } from './AppBaseComponents/web-recorder-session/web-recorder-session.component';
import { FeatureAccessModule } from './shared/feature-access.module';
import { AccessRequiredViewComponent } from './Views/access-required-view/access-required-view.component';
import { ReadOnlyBadgeComponent } from './shared/read-only-badge/read-only-badge.component';
import { WebRecorderComponent } from './Views/web-recorder/web-recorder.component';
import { WebRecorderSavedStepsComponent } from './Views/web-recorder-saved-steps/web-recorder-saved-steps.component';
import { WebRecordedStepsComponent } from './Views/web-recorded-steps/web-recorded-steps.component';
import { SimulatorToolbarComponent } from './Views/simulator-toolbar/simulator-toolbar.component';
import { NamePromptModalComponent } from './AppBaseComponents/name-prompt-modal/name-prompt-modal.component';
import { ElementDetailsModalComponent } from './AppBaseComponents/element-details-modal/element-details-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginViewComponent,
    ReadOnlyBadgeComponent,
    LibraryViewComponent,
    StudioViewComponent,
    ReportViewComponent,
    PageNotFoundViewComponent,
    AccessRequiredViewComponent,
    PagePreviewComponentComponent,
    TopNavComponentComponent,
    SafePipePipe,
    PaletteComponentComponent,
    PaletteListComponentComponent,
    FeatureComponent,
    ScenarioListComponent,
    ScenarioComponent,
    StepListComponent,
    StepComponent,
    TextFilterPipe,
    SidebarMainComponent,
    SidebarListComponent,
    StepViewComponent,
    ObjectListMainComponent,
    ObjectListLinearComponent,
    FeatureListLinearComponent,
    FeatureListMainComponent,
    Canvas2Component,
    VideoComponent,
    LogsComponent,
    HtmlComponent,
    DoughnutComponent,
    SafePipe,
    CanvasComponent2Component,
    DragD1Component,
    DragD2Component,
    DragParentComponent,
    DragD3Component,
    DragD4Component,
    AddPageComponent,
    AddWebObjectComponent,
    ReportStatsComponent,
    ExecutionContainerComponent,
    TestDataDialogComponent,
    FileUploadDnDComponent,
    ReportSummaryComponent,
    ReportDetailsComponent,
    DialogComponent,
    CsvWarningDialogComponent,
    HeadNavbarComponent,
    ProjectViewComponent,
    AddElementComponent,
    ProgressSpinnerComponent,
    SearchPipe,
    RunideComponent,
    PaginationComponent,
    LoaderComponent,
    UpdatePasswordViewComponent,
    StepwiseComponent,
    ForgotPasswordViewComponent,
    ResetPasswordViewComponent,
    DurationPipe,
    TreeTableComponent,
    OrgStructureViewComponent,
    BaseOverlayFormComponent,
    ShareTextModalComponent,
    VideoViewerViewComponent,
    LogViewComponent,
    ReportViewerViewComponent,
    CodeLinkageViewComponent,
    ProgressLoaderComponent,
    VisualComparisonComponent,
    CodeReviewViewComponent,
    CodeReviewCodeChangedComponent,
    CodeReviewReportComponent,
    CodeReviewConversationComponent,
    CodeReviewListViewComponent,
    AddCodeReviewComponent,
    TemplateComponent,
    GithubIntegrationViewComponent,
    CodeDiffViewerComponent,
    SafeHtmlPipe,
    BAReviewComponent,
    BusniessReviewComponent,
    MappingArtifactComponent,
    JiraIntegrationViewComponent,
    IntegrationViewComponent,
    MapProjectComponent,
    AgileIntegrationViewComponent,
    AddApiObjectComponent,
    SelectObjectTypeComponent,
    ImportApiObjectsComponent,
    ApiResponseComponent,
    SlackIntegrationComponent,
    NotificationProfileViewComponent,
    SelectiveImportComponent,
    UserGuideComponent,
    CiCdComponent,
    SuiteConfigSelectionDialogComponent,
    SuiteExecutionConfigDialogComponent,
    ReportdashboardComponent,
    TestCasesViewComponent,
    GenerateTestCaseComponent,
    AdminManagmentComponent,
    RaiseBugComponent,
    MobileStreamViewComponent,
    RecordedActionsComponent,
    ApkUploadComponent,
    GestureControlsComponent,
    DeviceScreenComponent, 
    MobileLiveViewComponent,
    ImageSnippetDialogComponent,
    SuiteCanvasDialogComponent,
    SchedulerComponent,
    CreateScheduleComponent,
    ScheduleListComponent,
    SchedulerExecutionHistoryComponent,
    WebRecorderSessionComponent,
    WebRecorderComponent,
    WebRecorderSavedStepsComponent,
    WebRecordedStepsComponent,
    SimulatorToolbarComponent,
    NamePromptModalComponent,
    ElementDetailsModalComponent,
    TemplateConfigDialogComponent,
    TemplateResultDialogComponent
  ],
  entryComponents: [
    AddPageComponent,
    AddElementComponent,
    AddWebObjectComponent,
    AddApiObjectComponent,
    AddCodeReviewComponent,
    DialogComponent,
    NamePromptModalComponent,
    ElementDetailsModalComponent,
    CsvWarningDialogComponent,
    SelectObjectTypeComponent,
    ImportApiObjectsComponent,
    ApiResponseComponent,
    SelectiveImportComponent,
    SuiteConfigSelectionDialogComponent,
    SuiteExecutionConfigDialogComponent,
    ExecutionContainerComponent,
    TestDataDialogComponent,
    ImageSnippetDialogComponent,
    SuiteCanvasDialogComponent,
    TemplateConfigDialogComponent,
    TemplateResultDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FeatureAccessModule,
    FormsModule,
    BrowserAnimationsModule,
    DragDropModule,
    MatMenuModule,
    MatIconModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    SnotifyModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    NgxFileDropModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatGridListModule,
    HttpClientModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatButtonModule,
    MatTreeModule,
    MatTableModule,
    ChartsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatChipsModule,
    // SocksJSModule.forRoot(),
    MatDialogModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    SharedService,
    LibraryViewComponent,
    RestService,
    StartupService,
    ApkUploadService,
    MobileSessionService,
    ProjectResolver,
    { provide: MAT_DATE_FORMATS, useValue: { display: { dateInput: 'YYYY-MM-DD' } } },
    WebsocketService,
    ThemeService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
